import { useQuery } from '@tanstack/react-query';
import { deliveryTrackingService } from '../services/delivery-tracking.service';

export function useOrderDeliveryTracking(orderId: string) {
  return useQuery({
    queryKey: ['order-delivery-tracking', orderId],
    queryFn: () => deliveryTrackingService.getOrderDeliveryTracking(orderId),
    enabled: !!orderId,
  });
}
